const {languages} = SETTINGS.LANGUAGES

export default function (showCode) {
  return languages.find(item => item.show_code === showCode)
}